import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { Notice } from '~/features/notice/types/notice.type';

/**
 * 공지사항 상세 조회
 * @description 특정 공지사항의 상세 정보를 조회합니다
 * @endpoint GET /admin/notices/{id}
 * @param id - 공지사항 ID
 * @returns 공지사항 상세 정보
 */
export function getNoticeApi(id: number) {
  return axiosInstance.get<ApiResponse<Notice>>(`/admin/notices/${id}`);
}
